module.exports = __webpack_public_path__ + "img/donante-radio-centro.b2ef7163.png";